import * as R from "ramda";
import { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import { configMonthToDateMekanik, monthOptions, yearOptions } from "../config";
import React from "react";
import { mapToObjectDDL } from "../../../../../common/mapper";
import { buildExcelRequestBodyJualPartMTDByMekanik } from "../configExcel";
import { saveAs } from "file-saver";

class LaporanMTDPartByMekanik extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      mechanicNameOptions: [],
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
    this.fetchDataMechanic();
  }

  componentDidUpdate(prevProps) {
    const prevCabang = prevProps.search?.selectedCabang;
    const currentCabang = this.props.search?.selectedCabang;

    if (prevCabang !== currentCabang && currentCabang) {
      this.fetchDataMechanic();
    }
  }

  fetchDataMechanic = async () => {
    const selectedCabang = this.props.search?.selectedCabang;
    if (!selectedCabang) return;

    const kodeCabang = [selectedCabang];

    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getMechanicForDropDownListDashboard,
      menuName:
        "Dashboard Level Kabeng Keatas - Laporan Harian Part By Mekanik",
      args: kodeCabang,
    });
    this.props.triggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        mechanicNameOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.mechanicName, item.idEmployee),
        ),
      });
    }
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanSalesPartMTD,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kabeng Keatas - Laporan Jual Part MTD By Mekanik",
        args: {
          kodeCabang: [this.props.search.selectedCabang],
          year: this.state.year?.value,
          month: this.state.month?.value,
          mechanic: this.state.mekanik ? [this.state.mekanik.value] : [],
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const rawData = res.data.data || [];
        const totalRow = rawData.find(
          (item) => item.partCategory?.toLowerCase() === "total",
        );

        const detailRows = rawData.filter(
          (item) => item.partCategory?.toLowerCase() !== "total",
        );
        const orderedData = totalRow ? [totalRow, ...detailRows] : detailRows;

        const mappedData = orderedData.map((item) => ({
          partCategory:
            item.partCategory?.toLowerCase() === "total"
              ? "TOTAL"
              : item.partCategory,

          lastMonthValue: Number(item.lastMonthValue || 0),
          thisMonthValue: Number(item.thisMonthValue || 0),
          growthPercent: Number(item.growthPercent || 0),
          projectionSales: Number(item.projectionSales || 0),
        }));

        this.setState({
          tableConfig: configMonthToDateMekanik,
          dataTable: mappedData,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.props.triggerLoading();
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { month, year, dataTable, mekanik } = this.state;
    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartMTDByMekanik({
        month,
        year: year.value,
        dataTable,
        mekanik,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName:
          "Dashboard Level Mekanik dan SA - Laporan Jual Part MTD By Mekanik",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_mekanik"
            box="search"
            name="mekanik"
            containerclassname="width width-250px"
            placeholder="Nama Mekanik"
            menuPosition="fixed"
            options={this.state.mechanicNameOptions}
            value={this.state.mekanik}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <div style={{ marginBottom: "30px" }}>
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
          />
        </div>

        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </>
    );
  }
}

export default LaporanMTDPartByMekanik;
